import Termite from '@divtel/termite';
import React from 'react';
import { Container as Grid } from 'react-bootstrap';
import ImpersonateUsers from './Users';

const Impersonate: React.FC = () => {

  return (
    // @ts-ignore
    <Termite app='Impersonate'>
      <div className='main-section'>
        <Grid style={{ paddingTop: 44 }}>
          <ImpersonateUsers />
        </Grid>
      </div>
    </Termite>
  );
}

export default Impersonate;